//! bad 18M import csc from 'country-state-city';

import React from 'react';

import { Svg2Step3 } from '../../../data/SVGs';
import useWindowSize from '../../../hooks/useWindowSize';
import SocieteGeneralisation from '../Profile/SocieteGeneralisation';
import { typeTraitementEnum } from './DonneesPersonnelsExpert';
import DrawSideBar from './SideBar';
import SideBarMobile from './SideBarMobile';
const ExpertStep4 = () => {

    const {device}=useWindowSize();
    return (
        <>
            <div style={{display:'flex',flexDirection:device=='desktop'? 'row':'column',alignSelf:'stretch'}}>
                {device=='desktop' &&
                <DrawSideBar />
                }

                {device!='desktop' &&
                    <SideBarMobile
                        etape={'Société'}
                        etapSuivante=''
                        number='4'
                    />
                }
                <div style={{display:'flex',width:device=='desktop'?'80%':'100%',justifyContent:'center',padding:device=='desktop'?'0px':'16px',paddingTop: '64px',}}>
                    <SocieteGeneralisation typeTraitement={typeTraitementEnum.EXPERT_COMPLETE_PROFILE}/>
                </div>
                {device=='desktop' &&
                <div style={{display:'flex',justifyContent:'flex-end',alignItems: 'center'}}>
                    <Svg2Step3 />

                </div>
                }
            </div>
        </>
    );
};

export default ExpertStep4;
